import { Box, Stack, styled } from '@mui/material';

export const VolumeSliderBox = styled(Box)`
  height: 60px;
  margin-bottom: 4px;
  background-color: ${({ theme }) => `${theme.palette.common.white}80`};
  padding-top: 8px;
  padding-bottom: 8px;
  border-radius: 22px;
  visibility: hidden;
`;

export const VolumeWraper = styled(Stack)`
  position: relative;
  width: 24px;
  top: -45px;
  align-items: center;
  height: 30px;
  z-index: 1000;

  &:hover {
    height: 100px;
    top: -30px;
    #volume-slider {
      visibility: visible;
    }
  }

  svg {
    margin-top: 4px;
  }
`;
